<template>
  <!-- Contenedor -->
  <v-container fluid>
    <!-- Snackbar para operaciones -->
    <v-snackbar v-model="snackbar" :timeout="timeout" :color="snackbarColor">
      {{ snackbarText }}
    </v-snackbar>
    <!-- Primera fila para el título de la página-->
    <DeltiaCard class="pb-6">
      <!-- Columna para el titulo -->
      <v-col cols="12">
        <!-- Título con el nombre del producto -->
        <p class="display-1 font-weight-bold mb-0 ml-1 pb-0">
          {{ product.name }}
        </p>
      </v-col>
      <!-- Columna para la información -->
      <v-col cols="12">
        <v-row>
          <!-- Columna para la imagen -->
          <v-col cols="12" md="2">
            <!-- Imagen del producto -->
            <v-img
              v-if="product.image_url"
              width="100%"
              height="180px"
              contain
              :src="product.image_url"
            />
            <v-img
              v-else
              width="100%"
              height="180px"
              src="https://748073e22e8db794416a-cc51ef6b37841580002827d4d94d19b6.ssl.cf3.rackcdn.com/not-found.png"
            />
          </v-col>
          <!-- Columnas de información del producto -->
          <v-col cols="12" md="10" justify="center">
            <!-- Fila para la información -->
            <v-row>
              <v-col class="ml-0 pl-0" cols="12" md="3">
                <v-col class="pt-0 pb-0" cols="12">
                  <p class="font-weight-medium mb-1 text--disabled">
                    Costo de producción
                  </p>
                </v-col>
                <!-- Precio de compra de un producto -->
                <v-col class="pt-0 pb-0">
                  <p class="content--text font-weight-medium mb-0">
                    $ {{ product.purchase_price }}
                  </p>
                </v-col>
              </v-col>
              <!-- Columna para precio de venta -->
              <v-col class="ml-0 pl-0" cols="12" md="3">
                <v-col class="pt-0 pb-0">
                  <p class="font-weight-medium mb-1 text--disabled">
                    Precio de venta
                  </p>
                </v-col>
                <!-- Precio de venta de un producto -->
                <v-col class="pt-0 pb-0">
                  <p class="content--text font-weight-medium mb-0">
                    $ {{ product.sale_price }}
                  </p>
                </v-col>
              </v-col>
              <!-- Columna para utilidad -->
              <v-col class="ml-0 pl-0" cols="12" md="3">
                <v-col class="pt-0 pb-0">
                  <p class="font-weight-medium mb-1 text--disabled">
                    Utilidad
                  </p>
                </v-col>
                <!-- Utilidad de un producto -->
                <v-col class="pt-0 pb-0">
                  <p class="content--text font-weight-medium mb-0">
                    $ {{ product.utility }}
                  </p>
                </v-col>
              </v-col>
              <!-- Columna para la fecha -->
              <v-col class="ml-0 pl-0" cols="12" md="3">
                <v-col class="pt-0 pb-0">
                  <p class="font-weight-medium mb-1 text--disabled">
                    Agregado
                  </p>
                </v-col>
                <!-- Utilidad de para la fecha -->
                <v-col class="pt-0 pb-0">
                  <p class="content--text font-weight-medium mb-0">
                    {{ formatDate(product.created_at) }}
                  </p>
                </v-col>
              </v-col>
              <!-- Columna para la descripción -->
              <v-col class="ml-0 pl-0" cols="12" md="6">
                <v-col class="pt-0 pb-0">
                  <p class="font-weight-medium mb-1 text--disabled">
                    Descripción
                  </p>
                </v-col>
                <!-- Utilidad de para la fecha -->
                <v-col class="pt-0 pb-0">
                  <p class="content--text font-weight-medium mb-0">
                    {{ product.description }}
                  </p>
                </v-col>
              </v-col>
            </v-row>
            <!-- Fila para el botón -->
            <v-row>
              <!-- Fila para actualizar el producto -->
              <v-col cols="12" md="4">
                <!-- Botón para actualizar el producto -->
                <UpdateProduct
                  :productId="product._id"
                  @product-error="onProductError"
                  @update-product="onProductUpdate"
                />
              </v-col>
              <v-col cols="12" md="4">
                <DeleteProduct
                  :productId="id"
                  @product-error="onProductError"
                  @product-deleted="onProductDeleted"
                />
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </DeltiaCard>
    <!-- Fila para la sección de sucursales -->
    <DeltiaCard class="pb-6">
      <!-- Columna para el título -->
      <v-col cols="12">
        <p class="text-h5 font-weight-medium mb-0 pb-0">Sucursales</p>
      </v-col>
      <!-- Columna para activar el inventario -->
      <v-col v-if="activeBranches.length > 0" cols="12">
        <v-checkbox
          label="Activar control de inventario"
          v-model="product.stock_control"
          color="secondary"
          @change="updateStockControl"
        />
      </v-col>
      <!-- Columna de texto para sucursales activas -->
      <v-col v-if="activeBranches.length > 0" cols="12">
        <p class="mb-1 font-weight-medium text--disabled">Disponible en</p>
        <v-divider></v-divider>
      </v-col>
      <!-- Columna para las sucursales activas -->
      <v-col cols="12">
        <!-- Fila para cada sucursal -->
        <v-row
          v-for="branch in activeBranches"
          :key="branch._id"
          class="mt-3 mb-3"
          no-gutters
        >
          <!-- Nombre de la sucursal -->
          <v-col :cols="product.stock_control ? '3' : '11'">
            <!-- Nombre de la sucursal -->
            <p class="text-overline">{{ branch.name }}</p>
          </v-col>
          <!-- Cantidad disponible (si el inventario está activado) -->
          <v-col cols="8" v-if="product.stock_control">
            <!-- Campo de texto -->
            <TextField
              placeholder="Cantidad disponible"
              v-model="branch.quantity"
              @input="quantity => updateStock(branch.stockId, quantity)"
            />
          </v-col>
          <!-- Quitar sucursal -->
          <v-col cols="1" align="center">
            <v-btn @click="setInactiveBranch(branch)" color="red darken-3" icon>
              <v-icon>mdi-minus</v-icon>
            </v-btn>
          </v-col>
          <!-- Línea divisora -->
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-col>
      <!-- Columna de texto para sucursales inactivas -->
      <v-col v-if="inactiveBranches.length > 0" cols="12">
        <p class="mb-1 font-weight-medium text--disabled">No disponible en</p>
        <v-divider></v-divider>
      </v-col>
      <!-- Columna para las sucursales inactivas -->
      <v-col v-if="inactiveBranches.length > 0" cols="12">
        <!-- Fila para cada sucursal -->
        <v-row
          v-for="branch in inactiveBranches"
          :key="branch._id"
          class="mt-3 mb-3"
          no-gutters
        >
          <!-- Nombre de la sucursal -->
          <v-col cols="11">
            <!-- Nombre de la sucursal -->
            <p class="text-overline">{{ branch.name }}</p>
          </v-col>
          <!-- Agregar sucursal -->
          <v-col cols="1" align="center">
            <v-btn @click="setActiveBranch(branch)" color="teal darken-3" icon>
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </v-col>
          <!-- Línea divisora -->
          <v-col cols="12">
            <v-divider></v-divider>
          </v-col>
        </v-row>
      </v-col>
    </DeltiaCard>
  </v-container>
</template>

<script>
// Importar servicios
import ProductsServices from "@/services/ProductsServices";
import BranchesServices from "@/services/BranchesServices";
import StocksServices from "@/services/StocksServices";

// Importar componentes
const UpdateProduct = () =>
  import("@/components/products/modals/UpdateProduct");
const DeleteProduct = () =>
  import("@/components/products/modals/DeleteProduct");
const DeltiaCard = () => import("@/components/DeltiaCard");
const TextField = () => import("@/components/TextField");

// Importar mixins
import dateFormat from "@/mixins/dateFormat.js";

export default {
  name: "ProductDetails",
  mixins: [dateFormat],
  components: {
    UpdateProduct,
    DeleteProduct,
    DeltiaCard,
    TextField
  },
  props: {
    id: {
      type: String
    }
  },
  data: function() {
    return {
      product: {},
      activeBranches: [],
      inactiveBranches: [],
      timeout: 4000,
      snackbarText: null,
      snackbar: false,
      snackbarColor: null
    };
  },
  created: async function() {
    this.updatePage();
  },
  methods: {
    updatePage: async function() {
      try {
        // Obtener productos
        this.product = await ProductsServices.getProductById(this.id);

        // Obtener inventarios
        const stocks = await StocksServices.getBranchesByProductId(this.id);

        // Obtener todas las sucursales
        const allBranches = await BranchesServices.getBranchesInUserProfile();

        // Filtrar las sucursales activas
        let activeBranches = allBranches.filter(branch => {
          return (
            stocks.filter(stock => stock.branch_id == branch._id).length > 0
          );
        });

        // Agregar datos extra a las sucursales
        activeBranches = activeBranches.map(branch => {
          // Obtener el inventario correspondiente
          const stock = stocks.filter(
            stock => stock.branch_id === branch._id
          )[0];

          // Agregar datos extra
          branch.stockId = stock._id;
          branch.quantity = stock.quantity;

          return branch;
        });

        // Filtrar las sucursales que no son del usuario
        const inactiveBranches = allBranches.filter(branch => {
          return (
            stocks.filter(stock => stock.branch_id == branch._id).length === 0
          );
        });

        this.activeBranches = activeBranches;
        this.inactiveBranches = inactiveBranches;
      } catch (err) {
        // Mostrar error
        this.onProductError(err.message);
      }
    },
    onProductError: async function(errorMessage) {
      // Actualizar datos del snackbar
      this.snackbarText = errorMessage;
      this.snackbarColor = "error";
      this.snackbar = true;
    },
    onProductUpdate: async function() {
      // Mostrar mensaje
      this.showSuccessMessage("Producto actualizado con éxito");

      // Actualizar página
      await this.updatePage();
    },
    onProductDeleted: async function() {
      // Actualizar datos del snackbar
      this.snackbarText = "Producto eliminado con éxito";
      this.snackbarColor = "success";
      this.snackbar = true;
    },
    onBranchesUpdate: async function() {
      // Actualizar datos del snackbar
      this.snackbarText = "Sucursales actualizadas con éxito";
      this.snackbarColor = "success";
      this.snackbar = true;

      // Obtener ingresos
      await this.updatePage();
    },
    showSuccessMessage: async function(message) {
      // Actualizar datos del snackbar
      this.snackbarText = message;
      this.snackbarColor = "success";
      this.snackbar = true;
    },
    updateStockControl: async function(isActive) {
      try {
        // Actualizar producto
        await ProductsServices.updateProdut(this.product._id, {
          stock_control: isActive
        });

        // Mostrar mensaje
        this.showSuccessMessage("Producto actualizado con éxito");
      } catch (err) {
        // Mostrar error
        this.onProductError(err.message);
      }
    },
    setInactiveBranch: async function(targetBranch) {
      try {
        // Remover relación entre el producto y la sucursal
        await StocksServices.removeBranchToProduct(
          this.product._id,
          targetBranch._id
        );

        // Actualizar producto
        await this.onBranchesUpdate();
      } catch (err) {
        // Mostrar error
        this.onProductError(err.message);
      }
    },
    setActiveBranch: async function(targetBranch) {
      try {
        // Crear relación entre el producto y la sucursal
        await StocksServices.addProductToBranch(
          this.product._id,
          targetBranch._id
        );

        // Actualizar producto
        await this.onBranchesUpdate();
      } catch (err) {
        // Mostrar error
        this.onProductError(err.message);
      }
    },
    updateStock: async function(stockId, quantity) {
      try {
        // Obtener cantidad segura
        const realQuantity = quantity === "" ? 0 : parseFloat(quantity, 10);

        // Actualizar stock
        await StocksServices.updateStock(stockId, realQuantity);

        // Mostrar mensaje de confirmación
        this.showSuccessMessage("Inventario actualizado con éxito");
      } catch (err) {
        // Mostrar un error
        this.onProductError(err.message);
      }
    }
  }
};
</script>
